/* eslint-disable */
import CloseIcon from '@mui/icons-material/Close'
import { Box, Button, IconButton, Modal, Typography } from '@mui/material'
import { Marker, Polyline } from '@react-google-maps/api'
import React from 'react'
import ApiService from '../../../../ApiService.js'
import { useStates } from '../../../../StateProvider.js'
import { TRIP_STOPS_URL } from '../../../../constants.js'
import '../../../../scss/gps.scss'
import { useEmulatorStore } from '../../../../stores/emulator/store.tsx'
import { SelectedBreakInfo } from './SelectedBreakInfo.jsx'
import { SelectedStopInfo } from './SelectedStopInfo.jsx'
import { compareTripDataChangedNullOrId } from './utils.tsx'
import { SelectedStartInfo } from './SelectedStartInfo.jsx'
import { SelectedEndInfo } from './SelectedEndnfo.jsx'

export function StopComponents() {
  const { showToast } = useStates()

  const [selectedStop, setSelectedStop] = React.useState(null)
  const [dragStopsDetails, setDragStopsDetails] = React.useState({
    marker: {},
    stopNewLatLng: {},
    index: 0
  })

  const [selectedBreak, setSelectedBreak] = React.useState(null)

  let restCount = 0
  let breakCount = 0

  const [selectedStart, setSelectedStart] = React.useState(null)
  const [selectedEnd, setSelectedEnd] = React.useState(null)

  const [isStopsChangeVisible, setIsStopsChangeVisible] = React.useState(false)

  let defaultPathTraveled = useEmulatorStore(
    (state) => state.defaultPathTraveled
  )

  let alternativePathTraveled = useEmulatorStore(
    (state) => state.alternativePathTraveled
  )

  let updatedSelectedRouteDetails = useEmulatorStore(
    (state) => state.updatedSelectedRouteDetails
  )

  console.log('alternativePathTraveledTestData:', updatedSelectedRouteDetails)
  // console.log('alternativePathTraveled:', alternativePathTraveled)

  // Multiple route start lat and lng
  const multiStartLat = defaultPathTraveled[0]?.lat
  const multiStartLng = defaultPathTraveled[0]?.lng

  // Multiple route end lat and lng
  const multiEndLat = defaultPathTraveled[defaultPathTraveled.length - 1]?.lat
  const multiEndLng = defaultPathTraveled[defaultPathTraveled.length - 1]?.lng

  const handleMarkerClick = (stop) => {
    console.log('Stop clicked:', stop)
    setSelectedStop(stop)
  }

  const handleBreakMarkerClick = (breaks) => {
    console.log('breaksclicked:', breaks)
    setSelectedBreak(breaks)
  }

  const handleStartMarkerClick = (start) => {
    console.log('startclicked:', start)
    setSelectedStart(start)
  }

  const handleEndMarkerClick = (end) => {
    console.log('endclicked:', end)
    setSelectedEnd(end)
  }

  const handleInfoWindowClose = () => {
    setSelectedStop(null)
  }

  const handleInfoBreakWindowClose = () => {
    setSelectedBreak(null)
  }

  const handleInfoStartWindowClose = () => {
    setSelectedStart(null)
  }

  const handleInfoEndWindowClose = () => {
    setSelectedEnd(null)
  }

  const handleClose = () => {
    setIsStopsChangeVisible(false)
  }

  const tripData = useEmulatorStore(
    (state) => state.tripData,
    (oldTripData, newTripData) => {
      compareTripDataChangedNullOrId(oldTripData, newTripData)
    }
  )

  const selectedEmulator = useEmulatorStore((state) => state.selectedEmulator)

  const startLat = tripData?.tripPoints ? tripData?.tripPoints[0].lat : null
  const startLng = tripData?.tripPoints ? tripData?.tripPoints[0].lng : null
  const endLat = tripData?.tripPoints
    ? tripData?.tripPoints[tripData?.tripPoints?.length - 1].lat
    : null
  const endLng = tripData?.tripPoints
    ? tripData?.tripPoints[tripData?.tripPoints?.length - 1].lng
    : null

  const pathTraveled = useEmulatorStore((state) => state.pathTraveled)
  const pathNotTraveled = useEmulatorStore((state) => state.pathNotTraveled)

  const totalPath = pathTraveled?.concat(pathNotTraveled)

  const stopRefs = React.useRef({})

  let stopNewLatLng = null

  const handleStopDragEnd = (index) => {
    const marker = stopRefs.current[index]
    if (stopNewLatLng !== null) {
      marker.setPosition({ lat: stopNewLatLng.lat, lng: stopNewLatLng.lng })
    }
    console.log(
      'marker, stopNewLatLng, indexTest:',
      marker,
      stopNewLatLng,
      index
    )
    setDragStopsDetails({
      ...dragStopsDetails,
      marker,
      stopNewLatLng,
      index
    })
    // requestNewStopCreation(marker, stopNewLatLng, index)
    setIsStopsChangeVisible(!isStopsChangeVisible)
  }

  const handleStopDragged = (e, index, stop) => {
    // get new lat lng of the marker
    const lat = e.latLng.lat()
    const lng = e.latLng.lng()
    // snap to closest path lat lng
    const clickedLatLng = { lat, lng }
    const findClosestPointIndex = (path) => {
      return path.reduce((closestIndex, currentLatLng, index) => {
        const d1 =
          Math.pow(currentLatLng.lat - clickedLatLng.lat, 2) +
          Math.pow(currentLatLng.lng - clickedLatLng.lng, 2)
        const d2 =
          closestIndex === -1
            ? Infinity
            : Math.pow(path[closestIndex].lat - clickedLatLng.lat, 2) +
              Math.pow(path[closestIndex].lng - clickedLatLng.lng, 2)
        return d1 < d2 ? index : closestIndex
      }, -1)
    }

    const closestIndexPath = findClosestPointIndex(totalPath)
    if (
      closestIndexPath === null ||
      closestIndexPath < 0 ||
      closestIndexPath > totalPath.length
    ) {
      console.error('Could not find closest point in pathTraveled')
      return
    }

    // snap the marker from markerRef to the closest point in pathTraveled
    const marker = stopRefs.current[index]
    marker.setPosition({
      lat: totalPath[closestIndexPath].lat,
      lng: totalPath[closestIndexPath].lng
    })
    stopNewLatLng = {
      oldTripPointIndex: stop.tripPointIndex,
      newTripPointIndex: closestIndexPath,
      lat: totalPath[closestIndexPath].lat,
      lng: totalPath[closestIndexPath].lng
    }
  }

  async function requestNewStopCreation(marker, newLatLng, index) {
    if (isStopsChangeVisible === false) {
      stopNewLatLng = null
      // reset marker position to original
      if (
        tripData?.stops !== null &&
        tripData?.stops !== undefined &&
        tripData?.stops.length > 0
      ) {
        marker.setPosition({
          lat: tripData.stops[index].lat,
          lng: tripData.stops[index].lng
        })
      }
      return
    }

    setIsStopsChangeVisible(false)

    const token = localStorage.getItem('token')
    showToast('Updating Stop...', 'info')
    const { success, error } = await ApiService.makeApiCall(
      TRIP_STOPS_URL,
      'PUT',
      newLatLng,
      token,
      selectedEmulator.id
    )
    if (success) {
      showToast('Stop updated!', 'success')
      stopNewLatLng = null
    } else {
      showToast(error, 'error')
      stopNewLatLng = null
    }
  }

  return (
    <>
      {/* Stops --> it is act like rest areas (that comes after creation of trip) */}
      {tripData?.stops != null &&
        tripData?.stops.map((stop, index) => (
          <div key={stop.currentTripPointIndex}>
            <Marker
              key={stop.currentTripPointIndex}
              onLoad={(marker) => {
                stopRefs.current[index] = marker
              }}
              position={{
                lat: stop.lat,
                lng: stop.lng
              }}
              label={`R${index + 1}`}
              draggable={true}
              onClick={() => handleMarkerClick(stop)}
              onDragEnd={() => handleStopDragEnd(index)}
              onDrag={(event) => handleStopDragged(event, index, stop)}
            />
            {stop.tripPoints && stop.tripPoints?.length > 0 && (
              <Polyline
                key={stop.currentTripPointIndex}
                path={stop.tripPoints}
                options={{
                  strokeColor: '#FF2200',
                  strokeWeight: 6,
                  strokeOpacity: 0.6,
                  defaultVisible: true
                }}
              />
            )}
            {stop.tripPoints && stop.tripPoints?.length > 0 && (
              <Polyline
                key={stop.currentTripPointIndex}
                path={stop.returnTripPoints}
                options={{
                  strokeColor: '#7F00FF',
                  strokeWeight: 6,
                  strokeOpacity: 0.6,
                  defaultVisible: true
                }}
              />
            )}
          </div>
        ))}

      {/* Breaks that comes after creation of trip */}
      {tripData?.breaksV2 != null &&
        tripData?.breaksV2.map((breaks, index) => (
          <div key={breaks.currentTripPointIndex}>
            <Marker
              key={breaks.currentTripPointIndex}
              onLoad={(marker) => {
                console.log('selectedRoute', marker)
              }}
              position={{
                lat: breaks?.lat,
                lng: breaks?.lng
              }}
              label={`B${index + 1}`}
              draggable={false}
              onClick={() => handleBreakMarkerClick(breaks)}
              // onDragEnd={() => handleStopDragEnd(index)}
              // onDrag={(event) => handleStopDragged(event, index, breaks)}
            />
            {breaks.tripPoints && breaks.tripPoints?.length > 0 && (
              <Polyline
                key={breaks.currentTripPointIndex}
                path={breaks.tripPoints}
                options={{
                  strokeColor: '#FF2200',
                  strokeWeight: 6,
                  strokeOpacity: 0.6,
                  defaultVisible: true
                }}
              />
            )}
            {breaks.returnTripPoints && breaks.returnTripPoints?.length > 0 && (
              <Polyline
                key={breaks.currentTripPointIndex}
                path={breaks.returnTripPoints}
                options={{
                  strokeColor: '#7F00FF',
                  strokeWeight: 6,
                  strokeOpacity: 0.6,
                  defaultVisible: true
                }}
              />
            )}
          </div>
        ))}

      {endLat !== null && endLng !== null && (
        <Marker
          position={{ lat: startLat, lng: startLng }}
          onClick={() => handleStartMarkerClick(tripData?.emulatorDetails)}
          icon={{
            url: 'images/Origin.svg',
            scaledSize: new window.google.maps.Size(30, 30),
            anchor: new window.google.maps.Point(12, 30),
            scale: 1,
          }}
           zIndex={999}
        />
      )}

      {endLat !== null && endLng !== null && (
        <Marker
          position={{ lat: endLat, lng: endLng }}
          onClick={() => handleEndMarkerClick(tripData?.emulatorDetails)}
          icon={{
            url: 'images/Destination.svg',
            scaledSize: new window.google.maps.Size(30, 30),
            anchor: new window.google.maps.Point(12, 30),
            scale: 1
          }}
           zIndex={999}

        />
      )}

      {/* Multuple route start position */}
      {multiStartLat !== null &&
        multiStartLng !== null &&
        (defaultPathTraveled !== 0 || alternativePathTraveled[0] !== 0) && (
          <Marker
            position={{ lat: multiStartLat, lng: multiStartLng }}
            icon={{
              url: 'images/Origin.svg',
              scaledSize: new window.google.maps.Size(30, 30),
              anchor: new window.google.maps.Point(12, 30),
              scale: 1
            }}
          />
        )}

      {/* Multuple route end position */}
      {multiEndLat !== null &&
        multiEndLng !== null &&
        (defaultPathTraveled !== 0 || alternativePathTraveled[0] !== 0) && (
          <Marker
            position={{ lat: multiEndLat, lng: multiEndLng }}
            icon={{
              url: 'images/Destination.svg',
              scaledSize: new window.google.maps.Size(30, 30),
              anchor: new window.google.maps.Point(12, 30),
              scale: 1
            }}
          />
        )}

      {/* Multuple route trip markers */}
      {updatedSelectedRouteDetails?.alternativeRoute !== '' &&
        updatedSelectedRouteDetails?.points?.map((stop, index) => {
          let label = ''

          if (stop.restType === 'REST') {
            restCount++
            label = `R${restCount}`
          } else if (stop.restType === 'BREAK') {
            breakCount++
            label = `B${breakCount}`
          }
          return (
            <div key={index}>
              <Marker
                key={index}
                onLoad={(marker) => {
                  console.log('selectedRoute', marker)
                }}
                position={{
                  lat: stop?.location?.lat,
                  lng: stop?.location?.lng
                }}
                icon={{
                  // url: stop?.restType === 'BREAK' && 'images/map-breaks-icon.svg',
                  scaledSize: new window.google.maps.Size(30, 30),
                  anchor: new window.google.maps.Point(12, 30),
                  scale: 1
                }}
                label={label}
                draggable={false}
                // onClick={() => handleMarkerClick(stop)}
                // onDragEnd={() => handleStopDragEnd(index)}
                // onDrag={(event) => handleStopDragged(event, index, stop)}
              />
            </div>
          )
        })}

      {selectedStop && (
        <SelectedStopInfo
          selectedStop={selectedStop}
          handleInfoWindowClose={handleInfoWindowClose}
        />
      )}

      {selectedBreak && (
        <SelectedBreakInfo
          selectedStop={selectedBreak}
          handleInfoWindowClose={handleInfoBreakWindowClose}
        />
      )}

      {selectedStart && (
        <SelectedStartInfo
          selectedStart={selectedStart}
          handleInfoWindowClose={handleInfoStartWindowClose}
        />
      )}

      {selectedEnd && (
        <SelectedEndInfo
          selectedEnd={selectedEnd}
          handleInfoWindowClose={handleInfoEndWindowClose}
        />
      )}

      {/* Change stops Modal */}
      <div className="change-stops-main">
        <Modal
          open={isStopsChangeVisible}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="gps-set-position-box">
            {/* Close Button */}
            <IconButton
              edge="end"
              onClick={handleClose}
              aria-label="close"
              className="icon-btn"
            >
              <CloseIcon />
            </IconButton>

            {/* Header */}
            <Typography
              variant="h6"
              component="h2"
              className="set-position-header"
            >
              Change Stops
            </Typography>

            {/* Input Field */}
            <div className="set-change-stops-message">
              {`Change stop S${dragStopsDetails?.index + 1} location to this?`}
            </div>

            {/* Submit Button */}
            <Button
              onClick={() =>
                requestNewStopCreation(
                  dragStopsDetails?.marker,
                  dragStopsDetails?.stopNewLatLng,
                  dragStopsDetails?.index
                )
              }
              className="custom-font set-position-btn"
            >
              Ok
            </Button>
          </Box>
        </Modal>
      </div>
    </>
  )
}
